import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { joinGroup } from 'state/actions/groups'

import HomeNewsTagPage from '../HomeNewsTagPage'
import WhenLoggedIn from 'components/WhenLoggedIn'
import WhenNotLoggedIn from 'components/WhenNotLoggedIn'
import RequiresRegistration from 'components/RequiresRegistration'
import Card from 'components/Card'
import PleaseWait from 'components/PleaseWait'
import GroupSummary from 'components/GroupSummary'
import styles from './HomeNewsTagCirclesPage.css'

const Suggestion = ({ value }) => (
  <Card>
    <GroupSummary group={value} />
  </Card>
)

const LoggedInGroups = ({ discover: { suggestions } = {} }) => {
  if (suggestions?.length) {
    return (
      <section key="circles" className={styles.home_news_tag_circles}>
        {suggestions.map(suggestion => (
          <Suggestion
            key={suggestion._id}
            value={suggestion}
            join={joinGroup}
          />
        ))}
      </section>
    )
  }

  return (
    <PleaseWait key="nothing" i18nKey="group.discover.nothing_to_see" />
  )  
}

const HomeNewsTagCirclesContent = props => {
  return (
    <>
      <WhenLoggedIn>
        <LoggedInGroups {...props} />
      </WhenLoggedIn>,
      <WhenNotLoggedIn>
        <RequiresRegistration />
      </WhenNotLoggedIn>
    </>
  )
}

const HomeNewsTagCirclesPage = props => {
  return (
    <HomeNewsTagPage>
      <div className={styles.content}>
        <HomeNewsTagCirclesContent {...props} />
      </div>
    </HomeNewsTagPage>
  )
}

const mapStateToProps = ({
  discover: { loading, error, value: discover }
}) => ({
  loading,
  error,
  discover
})
const mapDispatchToProps = dispatch => ({
  joinGroup: bindActionCreators(joinGroup, dispatch),
  goToGroup: group => {
    dispatch({
      type: 'groups/group/posts',
      payload: {
        group: group._id
      }
    })
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(
  HomeNewsTagCirclesPage
)
